import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3844669d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "btu-areas"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("同 意")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("驳 回")

import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { ImagePreview } from 'vant'
import { getAiData, saveReview } from '@/api/ai'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

window.document.title = '异常报警详情'
const route = useRoute()
const data = ref()
data.value = route.query

const init = (id: string) => {
  getAiData({ id }).then((res) => {
    data.value = res
  })
}

init(route.query.id as string)

const showImg = (url: string) => {
  ImagePreview({
    // images: [data.value?.imageUrl],
    images: [url],
    closeable: true,
    closeIconPosition: 'bottom-left'
  })
}

const isLoading = ref(false)
const reviewAi = (approve: number) => {
  isLoading.value = true
  saveReview({
    id: route.query.id,
    approve
  }).then((res) => {
    isLoading.value = false
    init(route.query.id as string)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, "异常类型：" + _toDisplayString(data.value.eventTypeMessage), 1),
    _createElementVNode("p", null, "报警时间：" + _toDisplayString(data.value.createTime), 1),
    _createElementVNode("p", null, "门店名称：" + _toDisplayString(data.value.shopName), 1),
    _createElementVNode("p", null, "报警地点：" + _toDisplayString(data.value.channelName), 1),
    _createElementVNode("p", null, "主机IP：" + _toDisplayString(data.value.ip), 1),
    _createElementVNode("p", null, "序列号：" + _toDisplayString(data.value.deviceSerial), 1),
    _createElementVNode("p", null, "通道号：" + _toDisplayString(data.value.channelNo), 1),
    _createElementVNode("img", {
      src: data.value.drawImageUrl,
      alt: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showImg(data.value.drawImageUrl)))
    }, null, 8, _hoisted_2),
    (data.value.approve == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_van_button, {
            loading: isLoading.value,
            round: "",
            type: "primary",
            plain: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (reviewAi(2)))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_van_button, {
            loading: isLoading.value,
            round: "",
            type: "warning",
            plain: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (reviewAi(3)))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["loading"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})